<template>
  <div id="app" :class="currentLang">
    <CustomHeader></CustomHeader>
    <main id="content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>
import langMixin from './mixins/langMixin';
import CustomHeader from './components/Header.vue';
import CustomFooter from './components/Footer.vue';

export default {
  name: 'app',
  mixins: [langMixin],
  components: { CustomHeader, CustomFooter },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  @media screen {
    margin: ms(1);
    @include respond-to('tablet') {
      display: grid;
      justify-content: center;
      margin-top: ms(4)
    }
  }
}
#content {
  // required for transition effect?
  position: relative;
  top: 0;
}
</style>
